import React from 'react';
import MobileDevPageSide300x250Fs from './freestar/MobileDevPageSide300x250';
const MobileDevPageSide300x250 = ({ safety = 'off', safetyState })=>{
    return /*#__PURE__*/ React.createElement(MobileDevPageSide300x250Fs, {
        safety: safety,
        safetyState: safetyState
    });
};
MobileDevPageSide300x250.displayName = 'MobileDevPageSide300x250';
export default MobileDevPageSide300x250;
